import React, { ReactElement } from 'react';

import { DialogType } from '@philips-emr/hpms-stipulator-commons';

import { isDialogInformation } from './util-dialog-component';
import './subscription-information.scss';

interface SubscriptionInformationProps {
  type?: DialogType;
}

export function SubscriptionInformation(props: SubscriptionInformationProps): ReactElement | null {
  if (!isDialogInformation(props.type)) {
    return null;
  }

  return (<div className="c-dialog__wrapper__subscription-notice" ></div>);
}
